import { Controller } from "stimulus";
import { getRequest } from "init/ajax";

export default class extends Controller {
  static targets = [ "button", "discountCode"]

  handleResponseCallback(response) {
    if (response.is_available) {
      window.location.href = "/checkout"
    } else {
      document.querySelector('.js-BookNow__form').classList.add('BookNow__form-error')
      document.querySelector('.js-BookNow__check-in-date-visible').classList.add('BookNow__form-error-text')
      document.querySelector('.js-BookNow__check-out-date-visible').classList.add('BookNow__form-error-text')

      let errorMessageELement = `
            <div class='BookNow__form-error-message'>
              <div>Choose different dates</div>
              <div>Dates unavailable</div>
            </div>
            `

      document.querySelector('.js-BookNow__form')
        .insertAdjacentHTML("beforebegin", errorMessageELement)
    }
  }

  openDetails(event) {
    event.preventDefault();
    document.querySelector('.js-BookNow__rates-container').classList.toggle('BookNow__reveal')
    document.querySelector('.js-BookNow__details-min-total').classList.toggle('BookNow__arrow-up')
  }

  openCalendarModal(event) {
    event.preventDefault()

    let bookNowButtonElement = event.currentTarget     // this can be false if event is coming from or document object.
    let checkBookingAvailable = bookNowButtonElement ? bookNowButtonElement.dataset.bookNow : false
    let canFetchRates = bookNowButtonElement ? bookNowButtonElement.dataset.canFetchRates: false

    if (checkBookingAvailable === 'true') {
      let options = {
        url: document.querySelector('.js-BookNow__form').action,
        checkInDate: document.querySelector('.js-BookNow__check-in-date-hidden').value,
        checkOutDate: document.querySelector('.js-BookNow__check-out-date-hidden').value,
        handleResponseCallback: this.handleResponseCallback
      }

      this.isListingAvailable(options)

    } else if (canFetchRates === 'true') {
      const customEvent = new CustomEvent("fetch-rates", { bubbles: true });
      this.element.dispatchEvent(customEvent);
    } else {
      window.dispatchEvent(new Event('open-calendar-modal', {bubbles: true}));
    }
  }

  isListingAvailable(options = {}) {
    let propertyAvailAbleUrl = [`${options.url}?`, `check_in_date=${options.checkInDate}`, `&check_out_date=${options.checkOutDate}`].join('')
    getRequest(propertyAvailAbleUrl, event => {
      let response = JSON.parse(event.target.responseText);

      options.handleResponseCallback(response)
    })

  }

  async submit(event) {
    event.preventDefault();
    let formElement = event.currentTarget;

    let url = formElement.action
    let checkInDate = formElement.querySelector('#check_in_date').value
    let checkOutDate = formElement.querySelector('#check_out_date').value

    let fullRatesRequest = [`${url}?`, `check_in_date=${checkInDate}`, `&check_out_date=${checkOutDate}`].join('')

    getRequest(fullRatesRequest, event => {
      let response = JSON.parse(event.target.responseText);

      let strData = JSON.stringify(response, undefined, 2)

      document.querySelector('.rates-json').textContent = strData
    })
  }

  applyDiscount(event) {
    event.preventDefault();
    if(this.discountCodeTarget.value !== '') {
      // get current url and append discount code to it
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.set('coupon_code', this.discountCodeTarget.value);
      const newUrl = url.origin + url.pathname  + '?' + params.toString();

      window.location.href = newUrl;
    }
  }

}
